<template>
	<div>
		<div class="new-c">
			<div class="new-title show-one-lines" v-text="param.title"></div>
			<template v-for="(item,index) in param.list">
				<router-link :to="{path: '/shop', query: {mch_id: item.id}}"  class="store">
					<img class="store-img" :src="item.pic_url" alt />
					<div class="store-c">
						<div class="show-one-lines" v-text="item.name"></div>
						<div class="show-one-lines" v-text="item.subtitle"></div>
					</div>
					<div class="store-btn">进店看看</div>
				</router-link>
			</template>
			<div class="new-c-list clearfloat">
				<div class="new-c-item" v-for="(item,index) in param.brand_list" :key="index">
					<router-link :to="{path:'/list',query:{brand_id:item.id}}" v-if="index<12">
						<img :src="item.pic_url" alt />
						<div v-text="item.name"></div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {
				
			};
		}
	};
</script>

<style lang="scss" scoped>
	.new-c {
		width: 390px;
		margin-top: 20px;
		height: 417px;
		background-color: #fff;
		padding: 0 20px 20px 20px;
		box-sizing: border-box;
		overflow: hidden;
		.new-title {
			line-height: 56px;
			height: 56px;
			font-size: 18px;
			font-weight: 600;
		}

		.store {
			width: 350px;
			height: 83px;
			background-color: #f7f7f7;
			padding: 12px 16px;
			margin-bottom: 14px;
			box-sizing: border-box;
			display: flex;
			align-items: center;

			.store-img {
				height: 60px;
				width: 60px;
			}

			.store-c {
				width: 160px;
				margin-left: 12px;

				:first-child {
					font-size: 16px;
					font-weight: 600;
				}

				:last-child {
					color: #666666;
					margin-top: 10px;
				}
			}

			.store-btn {
				width: 80px;
				height: 24px;
				background: linear-gradient(270deg,
					rgba(255, 14, 37, 1) 0%,
					rgba(255, 144, 16, 1) 100%);
				border-radius: 15px;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #fff;
				margin-left: auto;
			}
		}

		.new-c-list {
			display: flex;
			flex-wrap: wrap;

			.new-c-item {
				width: 100px;
				margin-bottom: 14px;
				margin-right: 25px;
				float: left;
				transition: .5s;
				-moz-transition: .5s;
				-webkit-transition: .5s;
				-o-transition: .5s;

				a {
					display: block;
				}

				&:nth-child(3n) {
					margin-right: 0;
				}

				&:hover {
					opacity: 0.8;
				}

				img {
					width: 100px;
					height: 50px;
					object-fit: contain;
				}

				div {
					margin-top: 6px;
					text-align: center;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					transition: .5s;
					-moz-transition: .5s;
					-webkit-transition: .5s;
					-o-transition: .5s;
				}

				&:hover div {
					color: #FF0E25;
				}
			}
		}
	}
</style>
